module.exports = __webpack_public_path__ + "static/media/looza-apple.8b3ce179.jpg";